import React from 'react';

const posts = [
  {
    date: '2024',
    title: 'Why Open Hardware Matters for Enterprise WiFi',
    summary: 'Vendor lock-in has long been the norm in enterprise networking. We explore how disaggregated architectures and open hardware are changing the economics of WiFi deployment.',
    readTime: '5 min read'
  },
  {
    date: '2024',
    title: 'AI/ML in Network Management: Beyond the Buzzwords',
    summary: 'How machine learning is actually being used in radio resource management — real-world examples of interference mitigation, channel optimization, and predictive maintenance.',
    readTime: '7 min read'
  },
  {
    date: '2024',
    title: 'The True Cost of WiFi in Multi-Dwelling Units',
    summary: 'Breaking down CapEx and OpEx for MDU WiFi deployments, and how NaaS models are making managed connectivity economically viable for property operators of all sizes.',
    readTime: '6 min read'
  },
  {
    date: '2023',
    title: 'Zero-Touch Provisioning: From Box to Operational in Minutes',
    summary: 'How cloud-native provisioning eliminates the need for on-site engineers and dramatically reduces deployment timelines for distributed network infrastructure.',
    readTime: '4 min read'
  }
];

const Blogs = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Blog</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Insights on enterprise networking, AI-powered network management, and the future of
          cloud-managed connectivity.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {posts.map((post, i) => (
            <article key={i} style={{
              padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#2563eb', fontSize: '0.85rem', fontWeight: '600' }}>{post.date}</span>
                <span style={{ color: '#64748b', fontSize: '0.85rem' }}>{post.readTime}</span>
              </div>
              <h2 style={{ fontSize: '1.3rem', marginBottom: '12px' }}>{post.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{post.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
